import { CircularProgress } from "@mui/material";
import { useState } from "react";
import { useWallet } from "../context/walletContext";
import { useNotify } from "../context/NotifyContext";
import { formatAmount } from "../utils/formatAmount";

const DTHForm = ({ data, onRecharge, loading }) => {
  const [amount, setAmount] = useState("");
  const { walletAmt } = useWallet();
  const { notify } = useNotify();

  const walletBalance = Number(walletAmt?.main?.balance || 0);

const handleSubmit = () => {
  const numericAmount = Number(amount);

  if (!numericAmount || numericAmount <= 0) {
    return notify("Please enter a valid amount", "error");
  }

  if (numericAmount > walletBalance) {
    return notify(
      `Insufficient wallet balance (₹${formatAmount(walletBalance)})`,
      "error"
    );
  }

  onRecharge(numericAmount);
};

  if (!data) return null;

  return (
    <div className="ds-card p-4">

      <div className="mb-3 border-b border-[var(--border-color)] pb-2 flex justify-between items-center">
        <span className="font-medium text-[var(--text-muted)]">Wallet Balance</span>
        <span className="font-semibold text-[var(--success-color)]">
          ₹ {formatAmount(walletBalance)}
        </span>
      </div>

      <h2 className="text-[15px] sm:text-lg font-semibold text-[var(--text-dark)] mb-4">
        Fetched Details
      </h2>

      <div className="space-y-3 sm:space-y-4">
        {[
          { label: "Balance", value: data.Balance },
          { label: "Monthly Recharge", value: data.MonthlyRecharge },
          { label: "Next Recharge Date", value: data.NextRechargeDate },
          { label: "Customer Name", value: data.customerName },
          { label: "Status", value: data.status },
        ].map((item, index) => (
          <div
            key={index}
            className="border-b border-[var(--border-color)] pb-2 grid grid-cols-2 text-[13px]"
          >
            <span className="text-[var(--text-muted)]">{item.label} :</span>
            <span className="font-semibold text-[var(--text-dark)]">{item.value}</span>
          </div>
        ))}

        <div>
          <span className="font-medium text-[var(--text-dark)] text-sm sm:text-base">
            Plan Name :
          </span>
          <div className="max-h-32 overflow-y-auto mt-2 border border-[var(--border-color)] p-2 rounded-md text-center make-text-primary text-xs sm:text-sm whitespace-pre-line">
            {data.planname?.split(",").join("\n")}
          </div>
        </div>

        <div className="mt-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 items-center">
            <label className="ds-label">
              Recharge Amount <span className="text-[var(--error-color)]">*</span>
            </label>
        <input
  type="text"
  placeholder="Enter Amount"
  value={amount}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");
    setAmount(value);
  }}
  className="ds-input"
/>

          </div>

          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className="ds-btn ds-btn-primary ds-btn-block mt-4"
          >
            {loading ? (
              <span className="inline-flex items-center gap-2">
                Processing...
                <CircularProgress size={16} sx={{ color: "inherit" }} />
              </span>
            ) : (
              "Complete Bill Payment"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DTHForm;
